var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-icon',_vm._b({class:{
    'is-animating': _vm.animate,
  },attrs:{"color":_vm.active ? 'accent' : _vm.color}},'v-icon',_vm.$attrs,false),[_vm._v(_vm._s(("$vuetify.icons." + (_vm.icon || _vm.$slots.default[0].text))))])}
var staticRenderFns = []

export { render, staticRenderFns }